import { toBoolean as m } from "@waitroom/utils";
import { differenceInHours as P, fromUnixTime as l } from "date-fns";
const A = 100, D = ["premium", "pro", "enterprise"], b = (e) => {
  var i;
  return !!e && ((i = e.scheduledChange) == null ? void 0 : i.action) === "cancel";
}, x = (e, i, t) => {
  var o;
  const r = (o = e == null ? void 0 : e.planConfig) == null ? void 0 : o.paddleProductName;
  return !!r && (Array.isArray(i) ? i.includes(r) : r === i) && (!t || a(e));
}, B = (e) => !e || e === "free", F = (e) => {
  var i;
  return !e || ((i = e.planConfig) == null ? void 0 : i.paddleProductName) === "free";
}, a = (e) => !!e && e.status === "trialing", h = (e) => a(e) && !(e != null && e.nextBilledAt) && !b(e), N = (e) => F(e) || h(e), g = (e, i) => {
  var t, r;
  return e ? ((t = e.planConfigOverrides) == null ? void 0 : t[i]) || ((r = e.planConfig) == null ? void 0 : r[i]) : void 0;
}, E = (e, i) => {
  var t;
  return !!((t = g(e, i)) != null && t.enabled);
}, q = (e, i) => {
  var t;
  return !((t = g(e, i)) != null && t.enabled);
}, v = (e) => e && e.status === "trialing" && e.trialEndsAt ? Math.max(Math.ceil(P(l(e.trialEndsAt), /* @__PURE__ */ new Date()) / 24), 0) : 0, I = (e) => !(e != null && e.id) || v(e) > 0, y = (e, i, t) => {
  var n, d, f, u;
  if (!((n = e == null ? void 0 : e.prices) != null && n.length)) return;
  let r, o;
  for (let s = 0; s < e.prices.length; s++) {
    const c = e.prices[s];
    if (((d = c.billingCycle) == null ? void 0 : d.interval) === i && c.status !== "archived" && (t === void 0 || !!((f = c.trialPeriod) != null && f.frequency) === t) && (o = c, m((u = c.customData) == null ? void 0 : u.default))) {
      r = c;
      break;
    }
  }
  return r || o;
}, M = (e, i, t) => {
  var r;
  if (e)
    for (let o = 0; o < e.length; o++) {
      if (((r = e[o].config) == null ? void 0 : r.paddleProductName) !== i) continue;
      const n = y(e[o], t);
      if (n) return n;
    }
}, O = (e) => {
  var i;
  return e ? ["error", "action_required"].includes((i = e.lastPayment) == null ? void 0 : i.status) : !1;
}, k = (e, i) => e == null ? void 0 : e.find((t) => t.id === i), w = (e, i) => e == null ? void 0 : e.find((t) => {
  var r;
  return ((r = t.config) == null ? void 0 : r.paddleProductName) === i;
});
export {
  w as findPlan,
  k as findPlanById,
  M as findPrice,
  g as getFeature,
  y as getPrice,
  v as getTrialDaysLeft,
  q as isFeatureDisabled,
  E as isFeatureEnabled,
  N as isFreeOrFreeTrialPlan,
  F as isFreePlan,
  h as isFreeTrialPlan,
  B as isFreeType,
  O as isPaymentFailing,
  b as isPlanCanceling,
  x as isPlanType,
  I as isTrialAvailable,
  a as isTrialPlan,
  D as premiumSubscriptionPlans,
  A as usdDivisor
};
